import { ShowcaseProject } from "./showcase-projects-types";

export class ShowcaseProjectsState {
	public projects: Array<ShowcaseProject> = [];
	public projectsBusy: boolean = false;

	public title: string = "";
	public platform: string = "";
	public search: string = "";
}